import angular from 'angular';
import moment from 'moment';

angular.module('cloudX').directive('cxYearSelect', [
  '$translate',
  function($translate) {
    return {
      restrict: 'E',
      template: `<select
            ng-model="value"
            ng-change="setValue(value)"
            ng-required="required"
            ng-disabled="disabled"
            id="{{inputId}}"
            class="form-control {{inputClass}}">
          <option value="" ng-show="!required || !value">{{placeholder}}</option>
          <option ng-value="0" ng-if="withoutOption">{{withoutOption}}</option>
          <option ng-value="year" ng-repeat="year in options">{{::year}}</option>
        </select>`,
      scope: {
        required: '@',
        placeholder: '@',
        inputClass: '@',
        inputId: '@',
        withoutOption: '@',
        disabled: '=?',
      },
      require: 'ngModel',
      link: function($scope, el, attrs, ngModel) {
        if (!ngModel) return;

        $scope.options = [];

        $scope.resetOptions = () => {
          $scope.options = [];
          const currentYear = moment.utc().year();
          const yearsInPast = angular.isDefined(attrs.yearsInPast)
            ? parseInt($scope.$eval(attrs.yearsInPast) || attrs.yearsInPast)
            : 5;
          const yearsInFuture = angular.isDefined(attrs.yearsInFuture)
            ? parseInt($scope.$eval(attrs.yearsInFuture) || attrs.yearsInFuture)
            : 1;

          const startYear = currentYear - Math.max(0, yearsInPast || 0);
          const endYear = currentYear + Math.max(0, yearsInFuture || 0);

          for (let y = startYear; y <= endYear; y++) {
            $scope.options.push(y);
          }

          if ($scope.value && $scope.value !== 0 && $scope.options.indexOf($scope.value) < 0) {
            $scope.options.push($scope.value);
          }
        };
        ngModel.$render = function() {
          $scope.value = ngModel.$viewValue;
          if (
            $scope.options.length === 0 ||
            ($scope.value && $scope.options.indexOf($scope.value) < 0)
          )
            $scope.resetOptions();
        };
        $scope.setValue = function(value) {
          if ((value === '0' || value === 0) && !!$scope.withoutOption) {
            ngModel.$setViewValue(0);
            return;
          }

          if (!value || value < 2000) {
            ngModel.$setViewValue(null);
          } else {
            ngModel.$setViewValue(parseInt(value));
          }
        };
      },
    };
  },
]);
